import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  MenuItemProps,
  Select,
  SelectProps,
} from "@mui/material";
import { ControlsProps } from "./types";

export type SelectFieldProps<
  T extends MenuItemProps["value"] = MenuItemProps["value"]
> = Pick<ControlsProps<T>, "onSelect" | "options" | "selected"> &
  Pick<SelectProps, "label" | "fullWidth" | "sx" | "required" | "disabled">;

export const SelectField = <T extends MenuItemProps["value"]>({
  onSelect,
  options,
  selected,
  label,
  fullWidth = false,
  sx,
  required,
  disabled,
}: SelectFieldProps<T>) => {
  return (
    <FormControl fullWidth={fullWidth} size="small" sx={sx} required={required}>
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={disabled || options.length === 0}
        label={label}
        value={selected}
        onChange={(evt) => onSelect(evt.target.value as T)}
      >
        {options.map(({ label, value }, index) => (
          <MenuItem key={index} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default SelectField;
